import CoachingForm from "../../components/CoachingForm/CoachingForm";
const EditCoachingBasic = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <CoachingForm type="Edit" />
        </div>
    )
}
export default EditCoachingBasic;